export default __webpack_public_path__ + "static/media/K420MANB1.c422a8a7.pdf";